// ======================================================================
// File Name       : CSVDownloadConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const TARGET_USER = {
  USER: '0',
  USER_GROUP: '1',
};

export const TARGET_ITEM = {
  COURSE: '0',
  ITEM: '1',
};

export const ITEM_TYPE = {
  DOCUMENT: '0',
  VIDEO: '1',
  DRILL_TEST_CORRECTION: '2',
  LINK: '3',
};

export const SELECTED_RANGE = {
  ALL: '0',
  USER: '1',
  GROUP: '2',
};

export const TARGET_CONTENT = {
  ALL: '0',
  COURSE: '1',
  CONTENT_TYPE: '2',
  CONTENT_SPECIFICATION: '3',
  BOX: '4', // Step 10.0.0
};

export const CONTENT_TYPE = {
  NO_SELECTION: '0',
  SERVICE_CONTENT: '1',
  EXTERNAL_CONTENT: '2',
};

export const CONTENT_TYPE_NAME = {
  VIDEO: 'ビデオ',
  DRILL: 'ドリル',
  DOCUMENT: 'ドキュメント',
  LINK: 'リンク',
};

// Step 10.0.0 START
export const SELECTED_COMPLETION_TYPE = {
  ALL: '0',
  COMPLETE: '1',
  INCOMPLETE: '2',
};

export const PROGRESS_STATUS_CSV_TYPE = {
  CONTENT: '0',
  BOX: '1',
  COURSE: '2',
};

export const TARGET_USER_TYPE = {
  ALL: '-1',
  ADMIN: '0',
  GUARDIAN: '1',
  STUDENT: '2',
  SUPERUSER: '3',
};
// Step 10.0.0 END
